import React from "react";

const schedule = [
  { day: "Monday",    focus: "Striking for MMA",       accent: true,  kids: true },
  { day: "Tuesday",   focus: "Sparring",               accent: false, kids: false },
  { day: "Wednesday", focus: "Grappling for MMA",      accent: true,  kids: true },
  { day: "Thursday",  focus: "Striking for MMA",      accent: true,  kids: false },
  { day: "Friday",    focus: "Grappling for MMA",     accent: true,  kids: true },
  { day: "Saturday",  focus: "Private Training Only", accent: false, kids: false },
  { day: "Sunday",    focus: "Closed",                accent: false, kids: false },
];

export default function Timetable() {
  return (
    <section
      id="timetable"
      data-testid="timetable-section"
      className="relative py-28 md:py-36 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#d4af37]" />
              <span className="text-xs uppercase tracking-[0.3em] text-[#d4af37] font-bold">
                Weekly Schedule
              </span>
            </div>
            <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl uppercase leading-[0.9]">
              Weekly <br /> <span className="text-[#d4af37]">Timetable.</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-sm text-sm md:text-base">
            Adult classes run for 60 minutes. MMA for Kids on Mon · Wed · Fri at
            4:30pm for 30 minutes. Pop in any time and check the gym out — the
            door's open. <span className="text-white/80">Timetable is subject to updates and changes.</span>
          </p>
        </div>

        <div className="border border-white/10 divide-y divide-white/10">
          <div className="hidden md:grid grid-cols-12 px-6 py-4 text-xs uppercase tracking-[0.25em] text-white/40">
            <div className="col-span-3">Day</div>
            <div className="col-span-4">Focus</div>
            <div className="col-span-2">Class Time</div>
            <div className="col-span-3">Private Training</div>
          </div>
          {schedule.map((row) => {
            const isWeekday = !["Saturday", "Sunday"].includes(row.day);
            return (
              <div
                key={row.day}
                data-testid={`timetable-row-${row.day.toLowerCase()}`}
                className="grid grid-cols-1 md:grid-cols-12 px-6 py-6 items-center hover:bg-white/[0.02] transition-colors gap-3"
              >
                <div className="md:col-span-3 font-heading text-2xl uppercase tracking-wide">
                  {row.day}
                </div>
                <div className="md:col-span-4">
                  <span
                    className={`inline-flex items-center text-sm uppercase tracking-[0.2em] ${
                      row.accent ? "text-[#d4af37]" : "text-white/70"
                    }`}
                  >
                    <span
                      className={`w-2 h-2 mr-3 ${
                        row.accent ? "bg-[#d4af37]" : "bg-white/30"
                      }`}
                    />
                    {row.focus}
                  </span>
                </div>
                <div className="md:col-span-2">
                  {isWeekday ? (
                    <div className="flex flex-col gap-1.5">
                      {row.kids && (
                        <span
                          data-testid={`timetable-kids-${row.day.toLowerCase()}`}
                          className="px-3 py-1.5 border border-white/30 text-[11px] tracking-wider text-white/80 font-bold inline-flex items-center gap-1.5 w-fit"
                        >
                          <span className="w-1.5 h-1.5 bg-white/60" />
                          4:30pm · MMA for Kids
                        </span>
                      )}
                      <span className="px-3 py-1.5 border border-[#d4af37]/60 text-xs tracking-wider text-[#d4af37] font-bold inline-flex items-center gap-1.5 w-fit">
                        <span className="w-1.5 h-1.5 bg-[#d4af37]" />
                        5:30pm · Adults
                      </span>
                    </div>
                  ) : (
                    <span className="text-xs text-white/40 tracking-wider">—</span>
                  )}
                </div>
                <div className="md:col-span-3">
                  {row.day === "Sunday" ? (
                    <span className="text-xs text-white/40 tracking-wider">—</span>
                  ) : (
                    <span className="text-xs tracking-wider text-white/70">
                      {isWeekday ? "6:00am – 6:30pm" : "6:00am – 6:30pm"}
                      <span className="block text-[10px] text-white/40 mt-1">
                        {isWeekday ? "(excl. 5:30pm class)" : "By appointment"}
                      </span>
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-8 flex flex-col md:flex-row md:items-center gap-4 md:gap-6 px-1">
          <div className="flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-white/60">
            <span className="w-2 h-2 bg-[#d4af37]" /> Adult Class (60 min)
          </div>
          <div className="flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-white/60">
            <span className="w-2 h-2 bg-white/60" /> MMA for Kids (30 min)
          </div>
          <div className="flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-white/60">
            <span className="w-2 h-2 bg-white/30" /> No Group Class
          </div>
          <div className="text-xs uppercase tracking-[0.2em] text-white/50 md:ml-auto">
            Private training slots — 30 · 45 · 60 min
          </div>
        </div>
      </div>
    </section>
  );
}
